import { RouteRecordRaw } from "vue-router";
const routes: RouteRecordRaw[] = [
  {
    path: "searchQuestionsByImage",
    name: "searchQuestionsByImage",
    component: () => import("@/views/search-questions-by-image/index.vue")
  }
];
export default routes;